import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Field, useBusy } from "../components/common";

export function AuthShell({ children, testid }) {
  const { lang, setLang } = useLang();
  return (
    <div className="min-h-screen flex flex-col justify-center px-6 py-10 sm:px-16 max-w-lg mx-auto" data-testid={testid}>
      <div className="flex justify-between items-center mb-8">
        <span className="grid place-items-center w-12 h-12 rounded-xl bg-[#D9531E] text-white font-extrabold text-lg">HC</span>
        <button className="btn-outline btn-sm" onClick={() => setLang(lang === "en" ? "es" : "en", false)} data-testid={`${testid}-lang-toggle`}>
          {lang === "en" ? "Español" : "English"}
        </button>
      </div>
      {children}
    </div>
  );
}

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, run] = useBusy();
  const submit = (e) =>
    run(async () => {
      e.preventDefault();
      try {
        await api.post("/auth/forgot-password", { email });
        setSent(true);
      } catch (err) {
        toast.error(errMsg(err));
      }
    });
  return (
    <AuthShell testid="forgot-password-page">
      <h1 className="text-3xl font-extrabold text-slate-900">{t("Forgot password?", "¿Olvidó su contraseña?")}</h1>
      {sent ? (
        <p className="mt-4 p-4 rounded-xl bg-emerald-50 text-emerald-800" data-testid="forgot-password-sent">
          {t("If that email belongs to an active account, we sent a reset link. It expires in 10 minutes.", "Si ese correo pertenece a una cuenta activa, enviamos un enlace para restablecer. Vence en 10 minutos.")}
        </p>
      ) : (
        <form onSubmit={submit} className="mt-6 grid gap-4">
          <p className="text-slate-600">{t("Enter your account email and we'll send you a secure reset link.", "Escriba el correo de su cuenta y le enviaremos un enlace seguro.")}</p>
          <Field label={t("Email", "Correo")}><input className="inp" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" /></Field>
          <button className="btn-primary h-14 text-base" disabled={busy} data-testid="forgot-submit-btn">{t("Send reset link", "Enviar enlace")}</button>
        </form>
      )}
      <Link to="/login" className="mt-6 text-sm font-semibold text-[#D9531E]" data-testid="forgot-back-to-login">{t("Back to sign in", "Volver a iniciar sesión")}</Link>
    </AuthShell>
  );
}
